interface TimestampedForecast {
  timestamp: string;
}

export const FISHING_DAY_START_HOUR = 6;
export const FISHING_DAY_END_HOUR = 18;

/** Open-Meteo timestamps are already expressed in the forecast location's local time. */
export const getForecastHour = (timestamp: string): number => Number(timestamp.slice(11, 13));

export const isFishingDayTimestamp = (timestamp: string): boolean => {
  const hour = getForecastHour(timestamp);
  return hour >= FISHING_DAY_START_HOUR && hour <= FISHING_DAY_END_HOUR;
};

/** Use the daytime planning window, falling back to available hours for partial forecasts. */
export const getFishingDayForecasts = <T extends TimestampedForecast>(forecasts: T[]): T[] => {
  const daytimeForecasts = forecasts.filter(forecast => isFishingDayTimestamp(forecast.timestamp));
  return daytimeForecasts.length ? daytimeForecasts : forecasts;
};
